<template>
    <layout>
        <div class="row">
            <div class="col-sm-12">
                <!-- Profile block -->
                <div :class="[working ? 'block-opt-refresh' : '', 'block', 'block-rounded']">
                    <div class="content content-boxed">
                    <!-- User Header -->
                        <div class="block">
                            <!-- Basic Info -->
                            <div class="bg-image">
                                <div class="block-content bg-primary-op text-center overflow-hidden">
                                    <div class=" push animated fadeInDown">
                                        <div class="item item-2x item-circle bg-crystal-op push-20-t push-20">
                                            <i class="icon-user text-white-op"></i>
                                        </div>
                                    </div>
                                    <div class="push-30 animated fadeInUp">
                                        <h2 class="h4 font-w600 text-white push-5">{{ user.contact.first_name + ' ' + user.contact.last_name}}</h2>
                                    </div>
                                </div>
                            </div>
                            <!-- END Basic Info -->
                        </div>
                        <!-- END User Header -->

                        <!-- Main Content -->

                            <div class="block">
                                <ul class="nav nav-tabs nav-justified push-20" data-toggle="tabs">
                                    <li class="active">
                                        <a href="#tab-profile-personal" id="personal-btn" v-on:click.prevent="updateTab('personal')"><i class="fa fa-fw fa-pencil"></i> Personal</a>
                                    </li>
                                    <li>
                                        <a href="#tab-profile-password" id="password-btn" v-on:click.prevent="updateTab('password')"><i class="fa fa-fw fa-asterisk"></i> Password</a>
                                    </li>
                                </ul>
                                <div class="block-content tab-content">
                                    <!-- Personal Tab -->
                                    <div class="tab-pane fade in active" id="tab-profile-personal">
                                        <div class="row items-push">
                                            <div class="col-sm-6 col-sm-offset-3 form-horizontal">
                                                <div class="form-group">
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.first_name">
                                                            <label class="text-muted">First Name</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.middle_name">
                                                            <label class="text-muted">Middle Name</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xs-12">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.last_name">
                                                            <label class="text-muted">Last Name</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="email" v-model="user.email">
                                                            <label class="text-muted">Email</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.phone">
                                                            <label class="text-muted">Phone</label>
                                                        </div>
                                                    </div>
                                                </div>
                                               <div class="form-group">
                                                    <div class="col-sm-12">
                                                        <div class="form-material">
                                                            <input class="form-control" type="company" v-model="user.contact.company">
                                                            <label class="text-muted">Company</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.address">
                                                            <label class="text-muted">Address</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.postal_code">
                                                            <label class="text-muted">Zip Code</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <input class="form-control" type="text" v-model="user.contact.locality">
                                                            <label class="text-muted">City</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-xs-6">
                                                        <div class="form-material">
                                                            <select class="form-control" v-model="user.contact.region_id">
                                                                <option v-for="region in regions" :value="region.id">{{ region.name }}</option>
                                                            </select>
                                                            <label class="text-muted">State</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END Personal Tab -->

                                    <!-- Password Tab -->
                                    <div class="tab-pane fade" id="tab-profile-password">
                                        <div class="row items-push">
                                            <div class="col-sm-6 col-sm-offset-3 form-horizontal">
                                                <div class="form-group" v-bind:class="{ 'has-error': $v.password.$error }">
                                                    <div class="col-xs-12">
                                                        <label for="profile-password-new">New Password</label>
                                                        <input class="form-control input-lg" type="password" v-model.trim="password" @input="$v.password.$touch()">
                                                        <div class="help-block animated fadeInDown" v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</div>
                                                    </div>
                                                </div>
                                                <div class="form-group" v-bind:class="{ 'has-error': $v.repeatPassword.$error }">
                                                    <div class="col-xs-12">
                                                        <label for="profile-password-new-confirm">Confirm New Password</label>
                                                        <input class="form-control input-lg" type="password" v-model.trim="repeatPassword" @input="$v.repeatPassword.$touch()">
                                                        <div class="help-block animated fadeInDown" v-if="!$v.repeatPassword.sameAsPassword">Passwords must be identical.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END Password Tab -->
                                </div>
                                <div class="block-content block-content-full bg-gray-lighter text-center">
                                    <button class="btn btn-primary" v-on:click="updateUser"><i class="fa fa-check push-5-r"></i> Save Changes</button>
                                </div>
                            </div>

                        <!-- END Main Content -->
                    </div>
                </div>
                <!-- END profile block -->
            </div>
        </div>
    </layout>
</template>

<script>
    import { sameAs, minLength } from 'vuelidate/lib/validators';

    export default {
        name: 'profile',
        data () {
            return {
                working: true,
                user: this.$schema.map('user'),

                // user: {
                //     email: ''
                // },
                // contact: {
                //     first_name: '-',
                //     last_name: '-',
                //     phone: '',
                //     address: '',
                //     locality: '',
                //     region: {
                //         id: -1,
                //         abbr: '',
                //         title: '',
                //     }
                // }

                regions: [],
                password: null,
                repeatPassword: null
            };
        },
        validations: {
            password: {
                minLength: minLength(8)
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        },
        components: {
            layout: require('../layouts/default.vue')
        },
        methods: {
            updateTab (tab) {
                jQuery('#' + tab + '-btn').tab('show');
            },
            updateUser () {
                var self = this;
                this.working = true;

                if (this.password && !this.$v.$invalid || !this.password) {
                    // var saveUser = this.user;
                    // var saveContact = this.contact;

                    if (this.password) {
                        // saveUser.password = this.password;
                        this.user.password = this.password;
                    }

                    // var save = {
                    //     user: saveUser,
                    //     contact: saveContact
                    // };

                    this.axios.put('users/me', this.user).then((response) => {
                        self.$toasted.success('User details updated!');
                    }).then(() => {
                        self.working = false;
                    });
                } else {
                    this.$toasted.error('Password form has errors that need to be corrected.');
                    this.updateTab('password');
                    this.working = false;
                }
            },
            getUser () {
                var self = this;
                this.working = true;
                this.axios.get('users/me?include=contact').then((response) => {

                    //console.log(response);

                    self.user = response.data;

                    // self.user.email = response.data.email;
                    // self.contact = response.data.contact;
                    self.working = false;
                });
            }
        },
        created () {
            var self = this;
            this.axios.get('regions').then((response) => {
                self.regions = response.data.data;
            });

            this.getUser();
        }
    };
</script>



// WEBPACK FOOTER //
// profile.vue?8abdd556